import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 3rem 2rem;
  > ol {
    max-width: 465px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 2rem;
    @media only screen and (max-width: 1032px) {
      max-width: 100%;
      padding: 0;
    }

    > div {
      outline: 0;
    }
  }
  .active {
    outline: 0;
    > li {
      font-size: 38px;

      color: ${({ theme }) => theme.colors.buttonDefault};
    }
  }

  .slide-txt {
    text-align: center;
    margin-top: 1rem;
    font-size: 1.2rem;
    font-weight: 500;
    color: white;
    max-width: 600px;
    @media only screen and (max-width: 1032px) {
      color: black;
    }
  }
`

export const Item = styled.li`
  color: #c8c8c8;
  font-size: 28px;
  font-weight: 400;
  transition: ease all 400ms 50ms;
  margin-bottom: 2rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  ${({ comingSoon }) =>
    comingSoon &&
    `&:after {
    content: 'Coming Soon';
    background-color: #00044b;
    padding: 4px 14px;
    border-radius: 18px;
    font-size: 13px;
    color: white;
    font-weight: 500;
    opacity: 1 !important;
    margin-left: 10px;
    display: block;
    max-height: 20px;
  }`}

  &:hover {
    color: ${({ theme }) => theme.colors.buttonDefault};
    opacity: 0.8;
  }
`
export const SlideWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.buttonDefault};
  padding: 2.4rem;
  max-width: 719px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-shadow: 0 15px 25px rgba(80, 90, 255, 0.5);
  border-radius: 4px;
  @media only screen and (max-width: 1032px) {
    display: none;
  }
`

export const GraphicWrapper = styled.div`
  max-width: 827px;
  width: 100%;

  @media only screen and (max-width: 1032px) {
    display: none;
  }
`

export const MobileGraphicWrapper = styled.div`
  max-width: 827px;
  width: 100%;
  > p {
    color: black;
  }
  display: none;
  opacity: 0;
  height: 0;
  @media only screen and (max-width: 1032px) {
    display: block;
  }
  ${({ active }) =>
    active &&
    `opacity: 1; height: auto; margin-bottom: 3rem; transition: 300ms ease-in all;`}
`
